module.exports = __webpack_public_path__ + "static/media/Bhaksar Kamath Page-min.747dc930.jpg";